import { NoDataScreen } from "@dashboard/library";
import { useTranslation } from "react-i18next";

/**
 * Empty state shown on the assets page when a call has neither a recording
 * nor a transcription - there is no media to display, so we surface a clear
 * "no information" screen in place of the transcript panel (CI-6374).
 * Deliberately NOT a page-level gate: the layouts render it so Call info and
 * Notes stay reachable and the call can still be tagged (CI-6448). The rule
 * lives in useNoInformationRule (no recording AND no transcription).
 */
export function NoInformation() {
  const { t } = useTranslation();

  return (
    <NoDataScreen
      title={t("no_information.title")}
      subtitle={t("no_information.subtitle")}
      data-test="no-information-screen"
    />
  );
}
